import React from "react";
import { useTranslation } from "react-i18next";
import { fileStatus } from "src/pages/Studies/models/interfaces";

interface StatusTextProps {
	status?: string;
	status_log?: fileStatus;
	infoText?: string;
	isTemplate?: boolean;
}

const StatusText: React.FC<StatusTextProps> = ({ status, status_log, infoText, isTemplate }) => {
	const { t } = useTranslation();

	const getStatusIcon = (): string => {
		if (isTemplate) {
			return `${t("Generated")} ${infoText}`;
		}

		if (status_log === fileStatus.success || status_log === fileStatus.partial_processed) {
			return `${t("Uploaded successfully")} ${infoText}`;
		}

		if (status_log === fileStatus.failed || status_log === fileStatus.validation_failed) {
			return t("Processing failed");
		}

		if (status_log === fileStatus.upload_failed) {
			return t("Uploading failed");
		}

		if (status_log === fileStatus.uploading) {
			return t("Uploading…");
		}

		if (status_log === fileStatus.uploaded) {
			return t("File uploaded successfully, Process Pending");
		}

		return t("Processing…");
	};

	return <>{getStatusIcon()}</>;
};

export default StatusText;
